var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldCloseSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5F755180-7D08-4172-82F1-93C2CB7A9D37") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional---Bold",
    transform: "translate(-108.000000, -316.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-square",
    transform: "translate(108.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80999994,2 C4.16999984,2 2,4.16999984 2,7.80999994 L2,16.1800003 C2,19.8300004 4.16999984,22 7.80999994,22 L16.1800003,22 C19.8200004,22 21.9900341,19.8300006 21.9900341,16.1900005 L21.9900341,7.80999994 C22,4.16999984 19.8300006,2 16.1900005,2 L7.80999994,2 Z M15.3599997,15.3599997 C15.2099997,15.5099997 15.0199999,15.5799999 14.8299999,15.5799999 C14.6399999,15.5799999 14.4500002,15.5099997 14.3000002,15.3599997 L12,13.0600004 L9.69999981,15.3599997 C9.5499998,15.5099997 9.36000007,15.5799999 9.17000008,15.5799999 C8.98000008,15.5799999 8.79000035,15.5099997 8.64000034,15.3599997 C8.35000035,15.0699997 8.35000035,14.5900002 8.64000034,14.3000002 L10.9399996,12 L8.64000034,9.69999981 C8.35000035,9.40999982 8.35000035,8.93000033 8.64000034,8.64000034 C8.93000033,8.35000035 9.40999982,8.35000035 9.69999981,8.64000034 L12,10.9399996 L14.3000002,8.64000034 C14.5900002,8.35000035 15.0699997,8.35000035 15.3599997,8.64000034 C15.6499996,8.93000033 15.6499996,9.40999982 15.3599997,9.69999981 L13.0600004,12 L15.3599997,14.3000002 C15.6499996,14.5900002 15.6499996,15.0699997 15.3599997,15.3599997 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(-180.000000) translate(-12.000000, -12.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCloseSquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-close-square.acc14c3787cd577773259766eaecc7b1.svg";
export { ForwardRef as ReactComponent };